import React, { useState, useEffect } from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";

export default function Caesar() {
  const [includeÑ, setIncludeÑ] = useState(true);
  const [text, setText] = useState("");
  const [rotResults, setRotResults] = useState([]);

  const a26 = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const a27 = "ABCDEFGHIJKLMNÑOPQRSTUVWXYZ";

  const usedAlphabet = includeÑ ? a27 : a26;

  const applyRot = (input, shift) => {
      const alphabetLength = usedAlphabet.length;
      return input.split("").map((char) => {
        const isUpperCase = char === char.toUpperCase();
        const upperChar = char.toUpperCase();
        if (usedAlphabet.includes(upperChar)) {
          const newIndex = (usedAlphabet.indexOf(upperChar) + shift) % alphabetLength;
          const shiftedChar = usedAlphabet[newIndex];
          return isUpperCase ? shiftedChar : shiftedChar.toLowerCase();
        }
        return char;
      }).join("");
    };

  useEffect(() => {
    const maxRot = usedAlphabet.length;
    const results = [];
    for (let shift = 1; shift < maxRot; shift++) {
      results.push(applyRot(text, shift));
    }
    setRotResults(results);
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [text, includeÑ]);

  return (
  <>
    <HelmetProvider>
      <Helmet>
        <title>César | ERI</title>
      </Helmet>
    </HelmetProvider>
    <div id="ciphers" className="content">
      <div id="caesar" className="content-wrapper">
        <div className="content-title">
          <h1 className="title">César/ROT</h1>
          <p className="subtitle">El cifrado César consiste en sustituir cada letra del abecedario por una letra desplazada un número determinado de posiciones.</p>
        </div>
        <div className="content-main">
          <div className="content-code">
            <div className="content-encrypt">
              <label className="text-left" htmlFor="code">César/ROT</label>
              <textarea id="input-code" className="input-left" name="code" value={text} spellCheck="false"
                onChange={(e) => {
                  const clean = e.target.value.replace(/[^a-zA-ZÑñ ]/g, '').toUpperCase();
                  setText(clean);
                }}
              />
              <span className="info info-left">Carácteres permitidos: Letras y espacio</span>
              <div className="buttons">
              <div className="option">
                <label htmlFor="include-ñ">Incluir Ñ</label>
                <input type="checkbox" id="include-ñ" name="include-ñ" checked={includeÑ} onChange={() => {setIncludeÑ((v) => !v)}}/>
              </div>
              <div className="buttons-container">
                <button className="btn btn-primary" onClick={() => setText(text)}><span>Rotar </span><i className="fas fa-arrow-down"></i></button>
              </div>
              </div>
            </div>
          </div>
          <div className="content-table">
            <div className="table-wrapper">
              <table>
                <tbody>
                  {Array.from({ length: 26 }, (_, i) => (
                    <tr key={i + 1}>
                      <td className="code">ROT-{i + 1}</td>
                      <td className="text">{rotResults[i] || ""}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </>
  );
}
